import { render, staticRenderFns } from "./eventsCheck.vue?vue&type=template&id=147b2012&scoped=true&"
import script from "./eventsCheck.vue?vue&type=script&lang=js&"
export * from "./eventsCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147b2012",
  null
  
)

export default component.exports